module.exports = __webpack_public_path__ + "img/Icon-fwd-10s-hover.fa3ebf3f.svg";